import React, { useState } from 'react';
import { Menu as MenuIcon } from 'lucide-react';
import Menu from './Menu';
import { useNavigate } from 'react-router-dom';
import AuthObserver from '../../AuthObserver';
import { makeStyles } from '@material-ui/core/styles';

function NavBar(props) {
    const classes = useStyles();
    const [menuState, setMenuState] = useState(false);
    const navigate = useNavigate();

    return (
        <nav className={classes.navbar}>
            {props.Login !== null && props.Login.loginState &&
                <AuthObserver {...props} />
            }
            <div className={classes.inner}>
                <div className={classes.logoWrap}>
                    <img
                        onClick={() => navigate('/')}
                        src={process.env.PUBLIC_URL + "/images/brand/logo_taplr-dark.svg"}
                        alt="Taplr Logo"
                        className={classes.logo}
                    />
                </div>
                {props.Login.loginState &&
                    <div className={classes.actions}>
                        <Menu {...props} open={menuState} close={() => setMenuState(false)} />
                        <button
                            className={classes.menuBtn}
                            onClick={() => setMenuState(true)}
                            aria-label="Open menu"
                        >
                            <MenuIcon size={24} />
                        </button>
                    </div>
                }
            </div>
        </nav>
    );
}

const useStyles = makeStyles((theme) => ({
    navbar: {
        width: '100%',
        background: 'var(--color-bg-page)',
        display: 'flex',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        zIndex: 1000,
    },
    inner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '90%',
    },
    logoWrap: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '50%',
        },
    },
    logo: {
        height: '32px',
        width: 'auto',
        margin: '8px 0',
        cursor: 'pointer',
        [theme.breakpoints.up('sm')]: {
            height: '36px',
            margin: '12px 0',
        },
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        color: '#1D3557',
        [theme.breakpoints.up('sm')]: {
            width: '50%',
        },
    },
    menuBtn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '5px',
        padding: '8px',
        color: '#333333',
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: '50%',
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.85,
        },
    },
}));

export default NavBar;